/**
 * Copyright (c) 2022 FMR LLC.
 * All Rights Reserved.
 * Fidelity Confidential Information.
 */

import { Duration } from './../client.constants';

class FractionalCDOfferingsModel {
    public timestamp: string;

    public offerings: FractionalCDModel[];

    constructor(timestamp: string, offerings: FractionalCDModel[]) {
        this.timestamp = timestamp;
        this.offerings = offerings;
    }
}

class FractionalCDModel {
    public termToMaturity: Duration;

    public sliderRate: string;

    public minMaturityDate?: Date;

    public maxMaturityDate?: Date;

    public fractionalCD?: CDDetail;

    public wholeCD?: CDDetail;

    constructor(
        termToMaturity: Duration,
        sliderRate: string,
        minMaturityDate?: Date,
        maxMaturityDate?: Date,
        fractionalCD?: CDDetail,
        wholeCD?: CDDetail
    ) {
        this.termToMaturity = termToMaturity;
        this.sliderRate = sliderRate;
        this.minMaturityDate = minMaturityDate;
        this.maxMaturityDate = maxMaturityDate;
        this.fractionalCD = fractionalCD;
        this.wholeCD = wholeCD;
    }
}

class CDDetail {
    public cusip: string;

    public rate: number;

    public datedDate: string;

    public maturityDate: string;

    constructor(cusip: string, rate: number, datedDate: string, maturityDate: string) {
        this.cusip = cusip;
        this.rate = rate;
        this.datedDate = datedDate;
        this.maturityDate = maturityDate;
    }
}

export { CDDetail, FractionalCDOfferingsModel, FractionalCDModel };
